import { render } from "./FilterFailedTransactions.vue?vue&type=template&id=49d48df7&scoped=true"
import script from "./FilterFailedTransactions.vue?vue&type=script&lang=js"
export * from "./FilterFailedTransactions.vue?vue&type=script&lang=js"

import "./FilterFailedTransactions.vue?vue&type=style&index=0&id=49d48df7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d48df7"]])

export default __exports__